<template>
  <div :class="[isOpen ? 'is-open' : '', $mq === 'sm' ? 'panel-side-sm' : 'panel-side']">
    <div class="panel">
      <ul>
        <li v-for="year in selectableYears" :key="year" @click="selectYear(year)">
          <span>{{ year }} - {{ year + 9 }}</span>
          <div class="menu-icon">
            <vue-material-icon v-if="selectedYear === year" name="remove_circle_outline" :size="24"/>
            <vue-material-icon v-else name="add_circle" :size="24"/>
          </div>
        </li>

        <li @click="selectYear(null)">
          <span>Tutti gli anni</span>
          <div class="menu-icon">
            <vue-material-icon v-if="selectedYear === null" name="remove_circle_outline" :size="24"/>
            <vue-material-icon v-else name="add_circle" :size="24"/>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PanelYears",
    props: {
      isOpen: {
        type: Boolean,
        default: true
      },
      selectableYears: Array,
      selectedYear: Number
    },
    methods: {
      selectYear(year) {
        this.$emit('select-year', year)
      }
    },
    data() {
      return {}
    },
  }
</script>

<style lang="scss" scoped>
  .panel-years {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    width: 500px;
    transform: translateX(100%);
    transition: .2s ease-in-out;
    z-index: 10;

    &.is-open {
      transform: translateX(0%);
    }

    .panel {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: #fff;
      color: #000;
      overflow: auto;
      padding: 1em;

      ul {
        backface-visibility: hidden;
        list-style: none;
        margin: 0;
        padding: 0;
        width: 100%;
        overflow: visible;
        right: 0px;
        text-align: center;

        li {
          padding-top: 10px;
          display: block;
          position: relative;
          width: 430px;
          height: 70px;
          cursor: pointer;

          .material-icon {
            background-color: white;
            color: #000;
            border-radius: 60px;
            padding: 6px;
            opacity: .8;
          }

          .material-icon:hover {
            opacity: 1;
          }
        }
      }
    }
  }

  .panel-years-sm {
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100vh;
    transform: translateX(100%);
    transition: .2s ease-in-out;
    z-index: 10;

    &.is-open {
      transform: translateX(0%);
    }

    .panel {
      top: 0;
      bottom: 0;
      height: 100vh;
      background: #fff;
      color: #000;
      overflow: auto;
      padding: 0;

      ul {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        backface-visibility: hidden;
        list-style: none;
        margin: 0;
        padding: 0;
        width: 100%;
        overflow: visible;
        right: 0px;
        text-align: center;

        li {
          padding-top: 10px;
          display: block;
          width: 100vw;
          height: 70px;
          cursor: pointer;

          .material-icon {
            background-color: white;
            color: #000;
            border-radius: 60px;
            padding: 6px;
            opacity: .8;
          }

          .material-icon:hover {
            opacity: 1;
          }
        }
      }
    }
  }

  .selected {
    font-weight: bold;
  }

</style>
